import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

// Define the schema for a single element of the array
export const tagwallAccountsPayableAgingXlsxFileDataElementSchema = yup
  .object({
    vendorName: yup.string().nullable().optional(),
    invoiceId: yup.string().nullable().optional(),
    proposal: yup.string().nullable().optional(),
    description: yup.string().nullable().optional(),
    purchaseOrderNumber: yup.string().nullable().optional(),
    invoiceDate: yup.string().nullable().optional(),
    dueDate: yup.string().nullable().optional(),
    discountDueDate: yup.string().nullable().optional(),
    payablesReceived: yup.string().nullable().optional(),
    original: yup.string().nullable().optional(),
    openBalance: yup.string().nullable().optional(),
    currentAmount: yup.string().nullable().optional(),
    past30: yup.string().nullable().optional(),
    past60: yup.string().nullable().optional(),
    past90: yup.string().nullable().optional(),
    depositApplied: yup.string().nullable().optional(),
  })
  .required()

export const tagwallAccountsPayableAgingXlsxFileDataSchema = yup
  .object({
    rows: yup.array().of(tagwallAccountsPayableAgingXlsxFileDataElementSchema).required(),
  })
  .required()

export type TagwallAccountsPayableAgingXlsxFileData = yup.InferType<
  typeof tagwallAccountsPayableAgingXlsxFileDataSchema
>

// Type for a single element of the array
export type TagwallAccountsPayableAgingXlsxFileDataElement = yup.InferType<
  typeof tagwallAccountsPayableAgingXlsxFileDataElementSchema
>

// Use the element type for the mappings
type RequiredFileData = MakeRequiredAndNullable<TagwallAccountsPayableAgingXlsxFileData>

const rowMappings: MakeRequiredAndNullable<TagwallAccountsPayableAgingXlsxFileDataElement> = {
  vendorName: 'a97aaef4-0790-42d7-a59c-7ca258b002f0',
  invoiceId: '89ed621e-621f-420f-b5f9-4c2ca97eac0a',
  description: '2da4bda8-50b3-4f14-a021-1f4b1eda3b3b',
  proposal: '420a3565-e2d4-4206-8c60-1cca7d2e96b7',
  purchaseOrderNumber: 'c109ea9b-e3a1-46fc-b41f-aafa855e1aba',
  invoiceDate: 'c94f3cf8-1b0d-470f-9ba7-22602397d164',
  dueDate: '8763641a-c812-4bf0-a04e-3e9d93cef43b',
  discountDueDate: '9580888c-18f1-4925-a6b7-09d5dbe68342',
  payablesReceived: 'f1a90b9d-f09c-4e06-a572-8bb237750b37',
  original: '8cd8ef3e-5c58-49d0-b099-5475c436af04',
  openBalance: 'c8a5babe-d188-498f-aae8-61d1d47daa3d',
  currentAmount: '08905de2-c6e7-4594-a1bc-61675877cdef',
  past30: '8ef06038-52e9-4abb-8b2f-60e782f8f5e0',
  past60: '554ce15a-e0d7-425d-a0d6-f6f556d76289',
  past90: 'e747ba57-0e09-4336-a914-3045de542f4a',
  depositApplied: 'ac1f1b23-36b0-453d-bbe4-b11ea3d43f30',
}

export const tagwallAccountsPayableAgingXlsxFileMappings: RequiredFileData = {
  rows: [rowMappings],
}
